var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"category-row",attrs:{"data-cy":"table-row-title","data-tooltip":_vm.params.node.data.category}},[(_vm.isSearch)?_c('router-link',{attrs:{"to":{
      name: 'keywordList',
      params: { id: _vm.params.node.data.category },
    }}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.params.node.data.title)}})]):_c('span',{domProps:{"innerHTML":_vm._s(_vm.params.node.data.title)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }